import { useMutation } from '@tanstack/react-query';

import api from '../../services/api';

export const attachMedia = (file: File) => api.upload('/api/frontend/media_attachments', { body: { file } });

const useAttachMedia = () => useMutation({ mutationFn: attachMedia });

export default useAttachMedia;
